const condo_sec1_part4Object = (payload) => {
  return {
    type: "condosec1part4",
    payload,
  };
};

export default condo_sec1_part4Object;
